<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-search @search="updateList">
				<c-form>
					<c-form-item type="input" label="项目名称" name="name"></c-form-item>
					<c-form-item type="input" label="企业名称" name="yzdw_name"></c-form-item>
					<c-form-item type="select" label="保单类型" name="bx_type_id" options="INSURANCE_TYPE"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate v-if="power('7')">
				<underwrite>保险办理</underwrite>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="状态"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="insuranceState[data.state]" :style="{'color': insuranceState[data.state].color}">{{insuranceState[data.state].name}}</span>
					</template>
				</c-table-column>
					
				<c-table-column
					label="项目名称"
					name="project_name"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="保单类型"
					name="bx_type_name"
					width="100"
				></c-table-column>
				
				<c-table-column
					label="被保险人"
					name="bbxr_name"
					width="180"
				></c-table-column>
				
				<c-table-column
					label="保单金额"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.bd_money}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
					width="160"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button v-if="[1,5].includes(data.state) && power('7')" @click="navigateTo('/transact/insurance/apply', {id: data.id}, true)">编辑</c-table-button>
						<c-table-button v-else-if="data.state == 2 && power('7')" @click="$refs.payment.open(data.id)">上传付款凭证</c-table-button>
						<c-table-button v-if="data.state == 3 && power('3')" @click="navigateTo('/transact/insurance/detail', {id: data.id}, true)">审批</c-table-button>
						<c-table-button v-else @click="navigateTo('/transact/insurance/detail', {id: data.id}, true)">详情</c-table-button>
						<c-table-button v-if="[1,2,5].includes(data.state) && power('7')" @click="deleteHandle(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
		
		<payment ref="payment" @resolve="$refs.table.update()"></payment>
	</app>
</template>

<script>
	import underwrite from '@/components/module/underwrite.vue'
	import payment from './insurance_payment.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			underwrite,
			payment
		},
		
		props: {
			scene: String
		},
		
		computed: {
			...mapGetters(['power', 'insuranceState'])
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList(data = {}) {
				if (this.scene == 'approve') {
					data.state = 3;
				} else if (this.scene == 'record') {
					data.states = [4, 5];
				}
				this.$refs.table.load({
					url: '/project/bx/list',
					data
				});
			},
			
			deleteHandle(data) {
				this.$confirm({
					text: '确定要删除此保单吗？',
					resolve: () => {
						this.request({
							url: '/project/bx/delete',
							data: {
								bx_id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
